import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';
import { Scrollbars } from 'react-custom-scrollbars';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100% - 8.5em);

  .content-os {
    width: calc(100% - 2em);
    margin-right: 2em;

    .alerta-rejeitado {
      background: #9a3636;
      border-radius: 0.3em;
      padding: 0.5em 1em;
      color: #fff;
      margin-bottom: 1em;

      p {
        font-size: 0.7em;
      }
    }
  }
`;

export const ThisCard = styled(Card)`
  margin-bottom: 1.3em;
  padding: 0.8em;
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  min-height: 8.2em;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 20px rgba(174, 177, 200, 0.05);
  background: ${Colors.Color1};

  ${props => {
    if (props?.ativo) {
      return `border: 0.1em solid ${Colors.Color8};`;
    }
  }}

  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .content-top {
      display: flex;
      flex-direction: column;

      .card-cod {
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 4em;

        .cod {
          font-size: 0.7em;
          font-weight: bold;
          color: ${Colors.Color4};
        }
      }

      .card-top {
        margin-top: 0.5em;
        line-height: 0.9em;

        .titulo {
          font-size: 0.8em;
          font-weight: bold;
          color: ${Colors.Color14};
        }

        .analista {
          font-size: 0.7em;
          font-weight: 600;
          color: ${Colors.Color14};
        }
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .data {
        font-size: 0.65em;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .projeto {
        font-size: 0.65em;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .cliente {
        font-size: 0.65em;
        font-weight: 600;
        color: ${Colors.Color14};
      }
    }
  }

  .content-os {
    margin-top: 1em;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;

    .right {
      display: flex;
      align-items: flex-start;
      /* width: 160px; */

      .status {
        transition: 0.1s ease;
        /* height: 2.4em; */
        /* min-width: 160px; */
        padding: 0.625em 1em;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 700;
        font-size: 0.6em;
        position: relative;
        border: none;
        border-radius: 0.6em;
        margin-left: 0.8em;
        background: ${Colors.Color2};
        color: ${Colors.Color7};

        .item-color {
          min-width: 1.2em;
          min-height: 1.2em;
          background: ${props => {
            return props?.corBackground;
          }};
          margin-left: 0.6em;
          border-radius: 0.2em;
        }
      }
    }

    .left {
      display: flex;
      gap: 0.5em;

      .horario {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .item-hora {
          display: flex;
          margin-bottom: 0.2em;

          .card-numero {
            background: ${Colors.Color4};
            border-radius: 0.4em;
            padding: 0.2em 0.6em;
            display: flex;
            flex-direction: row;
            width: 1.4em;
            height: 1.4em;
            justify-content: center;
            align-items: center;
            margin-left: 0.45em;

            .numero {
              font-size: 0.7em;
              font-weight: 600;
              color: white;
            }
          }

          .card-hora {
            background: ${Colors.Color2};
            border-radius: 0.4em;
            padding: 0.2em 0.6em;
            display: flex;
            flex-direction: row;
            height: 1.4em;
            margin-left: 0.45em;
            justify-content: center;
            align-items: center;

            .hora {
              font-size: 0.7em;
              font-weight: 600;
              color: ${Colors.Color4};
              width: 100%;
            }
          }
        }
      }
    }

    .totalizadores {
      display: flex;
      align-items: flex-start;
      gap: 0.5em;
      /* margin-left: 1em; */

      .desconto,
      .translado,
      .total {
        white-space: nowrap;
      }

      .desconto {
        padding: 0.2em 0em;
        font-size: 0.8em;
        font-weight: 600;
        color: ${Colors.Color14};
      }

      .translado {
        padding: 0.2em 0em;
        font-size: 0.8em;
        font-weight: 600;
        margin-left: 1em;
        color: ${Colors.Color14};
      }

      .card-total {
        background: ${Colors.Color2};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        /* height: 1.4em; */
        justify-content: center;
        align-items: center;

        .total {
          font-size: 0.75em;
          font-weight: bold;
          color: ${Colors.Color4};
          width: 100%;
        }
      }
    }
  }
`;

export const ThisCalendar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 24em;

  .calendario {
    display: flex;
    flex-direction: column;
    align-items: center;

    select {
      width: 17em;
      margin-bottom: 2em;
    }

    .meses {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;

      .mes {
        background: ${Colors.Color4};
        border-radius: 0.9em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: column;
        width: 3.5em;
        height: 3.8em;
        justify-content: center;
        align-items: center;
        margin-left: 0.45em;
        margin-right: 0.45em;
        margin-bottom: 0.45em;
        cursor: pointer;

        .titulo-mes {
          font-size: 0.9em;
          font-weight: 600;
          color: white;
        }

        .ano {
          font-size: 0.75em;
          color: white;
        }
      }

      .mes-desativo {
        border-radius: 1em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: column;
        width: 3.5em;
        height: 3.8em;
        justify-content: center;
        align-items: center;
        margin-left: 0.45em;
        margin-right: 0.45em;
        margin-bottom: 0.45em;
        cursor: pointer;

        .titulo-mes {
          font-size: 0.9em;
          font-weight: 600;
          color: ${Colors.Color14};
        }

        .ano {
          font-size: 0.75em;
          color: ${Colors.Color14};
        }
      }
    }
  }
`;

export const ScrollOS = styled(Scrollbars)`
  width: calc(100%) !important;
`;

export const TotalContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 1rem;
  margin-bottom: 1.3em;

  @media (max-width: 1450px) {
    flex-direction: column-reverse;
  }
`;

export const Status = styled.ul`
  font-size: 0.9em;
  font-weight: 600;
  color: ${Colors.Color14};
  width: 100%;

  border: 0.1rem solid rgba(255, 255, 255, 0.1);
  border-radius: 0.5rem;
  padding: 0.5rem;
`;

export const ProposalStateList = styled.li`
  display: flex;
  justify-content: space-between;
  gap: 0.4em;

  border-bottom: 0.1rem solid rgba(255, 255, 255, 0.1);

  span {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    font-size: 0.8em;
    font-weight: 500;
    color: ${Colors.Color14};
    min-width: 72px;

    &:first-child {
      justify-content: flex-start;
      min-width: 120px;
      font-weight: 400;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:before {
        content: '';
        display: inline-block;

        width: 0.5rem;
        height: 0.5rem;
        margin-right: 0.4rem;

        border-radius: 0.1rem;
        background-color: ${props => props.color};
      }
    }
  }

  &:last-child {
    padding-bottom: 0;
    border: none;
  }
`;
